export const editorX = 'editor_x'
export const classic = 'Editor1.4'
export const wem = 'wem'
